import React from 'react';
import { ContentData } from '../data/contentData';

interface FooterProps {
  content: ContentData;
}

const Footer: React.FC<FooterProps> = ({ content }) => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Rajuk College</h3>
            <p className="text-gray-600 mb-4">
              Providing quality education following the Ministry of Education guidelines while preserving our cultural heritage.
            </p>
            <div className="flex space-x-4">
              <button className="text-gray-300 hover:text-white transition-colors">
                <i className="fab fa-facebook text-xl"></i>
              </button>
              <button className="text-gray-300 hover:text-white transition-colors">
                <i className="fab fa-twitter text-xl"></i>
              </button>
              <button className="text-gray-300 hover:text-white transition-colors">
                <i className="fab fa-instagram text-xl"></i>
              </button>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><button className="text-gray-300 hover:text-white transition-colors">About Us</button></li>
              <li><button className="text-gray-300 hover:text-white transition-colors">Academics</button></li>
              <li><button className="text-gray-300 hover:text-white transition-colors">Admissions</button></li>
              <li><button className="text-gray-300 hover:text-white transition-colors">Contact</button></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Dhaka, Bangladesh</li>
              <li>+880 1234-567890</li>
              <li>info@rajukcollege.edu.bd</li>
              <li>Mon-Fri: 8:00 AM - 4:00 PM</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">{content.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
